import { Component, OnInit } from '@angular/core';
import * as Constants from '../../assets/constants/Constants';

@Component({
  selector: 'app-online-appointment',
  templateUrl: './online-appointment.component.html',
  styleUrls: ['./online-appointment.component.css']
})
export class OnlineAppointmentComponent implements OnInit {
  C = Constants;

  constructor() { }

  ngOnInit(): void {
  }

}
